module.exports = __webpack_public_path__ + "static/12mindful-228c39d9f979c83659f4925c3140f9fb.jpg";